const html = require("choo/html");
const SDCard = require("./elements/sdcard.js");
const Button = require("./elements/button.js");

module.exports = function BrowserView(state, emit) {
  emit("browser-loaded");

  const projects = state.availableProjects;

  const tutorials = projects.filter((p) => p.category === "tutorial");
  const examples = projects.filter((p) => p.category === "games");
  const sandbox = projects.filter((p) => p.category === "sandbox");

  const generateGrid = (projects, mode) =>
    projects.map((p) =>
      SDCard({
        title: p.title,
        image: p.thumbnail,
        color: "blue",
        disabled: false,
        onClick: mode === "tutorial" ? () => emit('pushState', `/#tutorial#${p.id}`) :
          () => emit('pushState', `/#bend#${p.id}`)
      })
    );

  // New: Generate grid for examples with character images
  const generateExampleGrid = (projects) =>
    projects.map((p) =>
      html`
        <div class="example-card-container">
          ${p["character-image"]
            ? html`<img class="character-img" src="${p["character-image"]}" alt="" />`
            : ""}
          ${SDCard({
            title: p.title,
            image: p.thumbnail,
            color: "blue",
            disabled: false,
            onClick: () => emit('pushState', `/#bend#${p.id}`)
          })}
        </div>
      `
    );


  return html`
    <div id="app">
      <div id="project-browser">

        <div class="hero-section">
         <div class="hero-content">
          <h1 class="hero-title">Create projects in Massa Mist with code stickers!</h1>
            <div class="hero-description">
            GameBender is a creative coding environment where you can build interactive projects using simple code stickers in the world of Massa Mist.
            </div>
          <div class="hero-fun-container">
            <img
              class="hero-video"
              src="/graphics/Understory%20landing-page.gif"
              alt="Fables and Futures walkthrough"
            />
            <div class="hero-jumble">
              <img src="/graphics/box.png" class="jumble-img box" alt="Box" />
              <img src="/graphics/coconut.png" class="jumble-img coconut" alt="Coconut" />
              <img src="/graphics/crystal.png" class="jumble-img crystal" alt="Crystal" />
              <img src="/graphics/door.png" class="jumble-img door" alt="Door" />
              <img src="/graphics/pin-sticker.png" class="jumble-img pin" alt="Pin Sticker" />
              <img src="/graphics/walk-sticker.png" class="jumble-img walk" alt="Walk Sticker" />
              <img src="/graphics/gravity-sticker.png" class="jumble-img gravity" alt="Gravity Sticker" />
              <img src="/graphics/apron.png" class="jumble-img apron" alt="Apron" />
              <img src="/graphics/flashlight.png" class="jumble-img flashlight" alt="Flower" /> 

              </div>
          </div>
        </div>
        </div>
        

        <div class="category-section tutorials left-info">
          <div class="category-info">
            <div class="category-header">Tutorials</div>
            <div class="category-description">Learn how to use GameBender with these step-by-step guides.</div>
          </div>
          <div class="category-items">${generateGrid(tutorials, "tutorial")}</div>
        </div>

        <div class="category-section examples right-info">
          <div class="category-info">
            <div class="category-header">Examples</div>
            <div class="category-description">Explore examples and remix them to create your own projects.</div>
          </div>
          <div class="category-items">${generateExampleGrid(examples)}</div>
        </div>

        <div class = "category-row">

        <div class="category-section sandbox left-info">
          <div class="category-info">
            <div class="category-header">Sandbox</div>
            <div class="category-description">Create your own projects from scratch.</div>
          </div>
          <div class="category-items">${generateGrid(sandbox, "edit")}</div>
        </div>

        <div class="category-section comic right-info">
         <div class="category-info">
            <div class="category-header">Comic</div>
            <div class="category-description">Get the Massa Mist comics!</div>
          </div>
          <div class="category-items">
            <a href="https://www.fablesandfutures.com/" target="_blank" rel="noopener noreferrer" class="comic-link">
              <img src="/graphics/fables-futures-comic.png" alt="Get the Massa Mist comics at Fables & Futures" class="comic-img" loading="lazy" />
            </a>
          </div>
        </div>
        </div>

      </div>
    </div>

    
  `;
};
